import React, { useEffect, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthCheck } from '../context/authCheck';
import { isPublicRespondentPath } from '../constants/publicRespondentRoutes';

// ADR-0013
const AuthRouteGate: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  const { authChecked, ensureAuthChecked } = useAuthCheck();
  const awaitingCheck = !authChecked && !isPublicRespondentPath(pathname);

  useEffect(() => {
    if (awaitingCheck) ensureAuthChecked();
  }, [awaitingCheck, ensureAuthChecked]);

  return awaitingCheck ? null : <>{children}</>;
};

export default AuthRouteGate;
